module.exports = __webpack_public_path__ + "static/media/bKash.3cee407b.svg";